module.exports = __webpack_public_path__ + "static/media/icon_checkin.1aab54b3.svg";